
import { Component, Prop, Vue } from 'vue-property-decorator';
import moment, { Moment } from 'moment-timezone';

@Component({})
export default class OrderedSchedule extends Vue {
	@Prop({ required: true })
	defaultSchedule!: string[];

	schedule = this.defaultSchedule;

	painting = false;

	base: Moment = moment().tz(moment.tz.guess()).startOf('day');

	static mappings: { [key: string]: string } = {
		c: 'is-danger',
		p: 'is-primary',
		o: 'is-success',
	};

	static nextState: { [key: string]: string } = {
		c: 'p',
		p: 'o',
		o: 'c',
	};

	get classes() {
		return this.schedule.map((day) =>
			day.split('').map((slot) => OrderedSchedule.mappings[slot])
		);
	}

	changeSlot(i: number, j: number) {
		Vue.set(
			this.schedule,
			i,
			this.schedule[i].slice(0, j) +
				OrderedSchedule.nextState[this.schedule[i][j]] +
				this.schedule[i].slice(j + 1)
		);
	}
}
